export default "__VITE_ASSET__Cm8IjzMY__"